import React, { useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import * as Sentry from '@sentry/react'
import { getSiteAnalytics } from '../../../services/manage'
import { ErrorBox } from '../../ErrorBox/ErrorBox'
import { addUpgradeReason } from 'utils/general'
import AnalyticsPaywall from '../AnalyticsPaywall/AnalyticsPaywall'
import { analyticFeatures } from 'constants'

const AnalyticsAll = ({ domain, trialMode, onUpgradeCTA }) => {
  const [hasErrored, setHasErrored] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [siteAnalytics, setSiteAnalytics] = useState({})

  useEffect(() => {
    if (!trialMode) {
      fetchAnalyticsInfo()
    }
  }, [])

  const fetchAnalyticsInfo = async () => {
    setHasErrored(false)

    const domainValue = typeof domain === 'object' ? domain.subdomain : domain
    setIsLoading(true)
    try {
      const { data } = await getSiteAnalytics({ domain: domainValue })
      setSiteAnalytics(data)
      setIsLoading(false)
    } catch (error) {
      setHasErrored(true)
      setIsLoading(false)
      Sentry.captureException(error, {
        tags: {
          section: 'ANALYTICS_BROWSER',
          ANALYTICS_BROWSER: 'true'
        }
      })
    }
  }

  const handleUpgrade = () => {
    addUpgradeReason('View Analytics')
    onUpgradeCTA()
  }

  return (
    <>
      {isLoading && (
        <div className="text-center p-3">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      {!isLoading && trialMode && (
        <AnalyticsPaywall
          titlePrefix="Upgrade to unlock"
          titleHighlight="Project Analytics"
          gifSrc="/assets/img/gifs/analytics.gif"
          onUpgrade={handleUpgrade}
          features={analyticFeatures}
        />
      )}
      {!isLoading && !trialMode && siteAnalytics?.sharedLink?.url && (
        <iframe
          title="plausible-embed"
          /* eslint-disable-next-line react/no-unknown-property */
          plausible-embed="true"
          id="plausible-iframe"
          src={`${siteAnalytics.sharedLink.url}&embed=true&theme=light`}
          style={{ width: '100%', height: '520px', border: '0' }}
          allowFullScreen
        ></iframe>
      )}
      {!isLoading && hasErrored && (
        <ErrorBox
          onClick={fetchAnalyticsInfo}
          message="Your browser may be blocking the analytics. Please open Tiiny Host in another browser, or open Tiiny Host in incognito mode, and try again"
        />
      )}
      {!isLoading && !trialMode && !siteAnalytics?.sharedLink?.url && !hasErrored && (
        <div className="text-center p-3 text-muted">Analytics data not available.</div>
      )}
    </>
  )
}

export default AnalyticsAll
